var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`h${_vm.size}`,{tag:"component",staticClass:"v-resume-title",class:`v-resume-title--${_vm.size}`},[_vm._v("\n\t"+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }